/* eslint-disable no-unused-vars*/
import React from 'react';
import { useSelector } from 'react-redux';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Layout, Col, Row } from 'antd';
import { get } from 'lodash';

import { StyledLogo } from './header.styles';
// import LogoImage from '../../../../public/assets/image/logo/Noklogic_Logo_Design3.png';
import { getCookie } from 'helper/cookie';
import { getBannerOwnerGroupUserById } from 'api/bannerOwner';
import { VITE_REACT_PATH_IMAGE } from 'src/private/config';

const { Header } = Layout;

interface PropsType {
  collapsed: boolean;
  setSideBarToggle: (value: boolean) => void;
}

const HeaderLayouts = (props: PropsType) => {
  const { setSideBarToggle, collapsed } = props;
  const isMobileView = useSelector(state => get(state, 'device.isMobileView', false));
  const token = getCookie('access_tokenltl');
  const [dataBanner, setDataBanner] = useState<any>({
    id: null,
    owner_id: null,
    group_user_id: null,
    banner_name: '',
    created_at: '',
    updated_at: '',
  });
  const dataUser: any = getCookie('dataUser');
  const parseDataUser = dataUser ? JSON.parse(dataUser) : null;

  const splitData = dataBanner?.banner_path_local?.split('/');
  const ImageLink = splitData ? `${VITE_REACT_PATH_IMAGE}/${splitData[4]}/${splitData[5]}` : null;

  const fetchBannerOwner = useCallback(
    async (query?: any) => {
      if (dataBanner?.id !== null) {
        // If dataBanner already has data, skip fetching
        return;
      }
      // setIsLoadingBankTransfer(true);
      const params = {
        group_user_id: Number(parseDataUser?.groupuser_id),
      };
      try {
        const responseData = await getBannerOwnerGroupUserById({ token, params: params });
        if (responseData?.status === 200) {
          const { data } = responseData;
          setDataBanner(
            data?.data || {
              id: null,
              owner_id: null,
              group_user_id: null,
              banner_name: '',
              created_at: '',
              updated_at: '',
              banner_path_local: '',
            },
          );
        } else {
          setDataBanner({
            id: null,
            owner_id: null,
            group_user_id: null,
            banner_name: '',
            created_at: '',
            updated_at: '',
          });
        }
      } catch (error) {
        setDataBanner({
          id: null,
          owner_id: null,
          group_user_id: null,
          banner_name: '',
          created_at: '',
          updated_at: '',
        });
      }
    },
    [token],
  );

  useEffect(() => {
    if (token) {
      fetchBannerOwner();
    }
  }, [token]);

  return (
    <Header
      className="site-layout-background"
      style={{
        padding: 0,
      }}
    >
      <Row>
        <Col
          span={isMobileView ? 4 : 4}
          style={{
            textAlign: 'center',
            left: 0,
            right: 0,
            position: 'relative',
            zIndex: 1,
            maxHeight: '65px',
          }}
        >
          <span className="trigger" onClick={() => setSideBarToggle(!collapsed)}>
            {collapsed ? (
              <>
                <MenuUnfoldOutlined />
              </>
            ) : (
              <>
                <MenuFoldOutlined />
              </>
            )}
          </span>
        </Col>
        {isMobileView ? (
          <Col
            span={24}
            style={{
              textAlign: 'center',
              left: 0,
              right: 0,
              top: 0,
              position: 'absolute',
              display: 'flex',
            }}
          >
            <span style={{ width: '100%', textAlign: 'center', justifyContent: 'center' }}>
              {/* <StyledLogo src={ImageLink ? ImageLink : LogoImage} alt="logo" /> */}
              {(dataBanner && ` ` + dataBanner?.banner_name) || ' Logo & Name'}
            </span>
            {/* {!collapsed && (
                      <div>
                        <span className='trigger'
                           onClick={() => setSideBarToggle(!collapsed)}
                        >
                           { collapsed ? (<><MenuUnfoldOutlined/></>) : (<><MenuFoldOutlined/></>)}
                        </span>
                     </div>
                  )} */}
          </Col>
        ) : (
          <Col
            span={24}
            style={{
              textAlign: 'center',
              left: 0,
              right: 0,
              top: 0,
              position: 'absolute',
              display: 'flex',
              maxHeight: '65px',
              marginLeft: '240px',
            }}
          >
            <span style={{ width: '100%', textAlign: 'center', justifyContent: 'center' }}>
              {/* <StyledLogo src={ImageLink ? ImageLink : LogoImage} alt="logo" /> */}
              {(dataBanner && ` ` + dataBanner?.banner_name) || ' Logo & Name'}
            </span>
          </Col>
        )}
      </Row>
    </Header>
  );
};

export default HeaderLayouts;
